import { defineStore } from 'pinia'

const TITLE_APP = import.meta.env.VITE_APP_NAME

interface State {
  title: string,
  showError403: boolean,
  showError404: boolean,
  showMaintenance: boolean,
  showMobileSidebar: boolean,
  back_navbar: object | null,
}

export const usePageStore = defineStore('Page', {
  state: (): State => ({
    title: '',
    showError403: false,
    showError404: false,
    showMaintenance: false,
    showMobileSidebar: false,
    back_navbar: null,
  }),
  actions: {
    setTitle (title: string) {
      this.title = title
      document.title = `${title} | ${TITLE_APP}`
    },
    setBackNavbar (data: object | null) {
      this.back_navbar = data
    },
    resetErrorState () {
      this.showError403 = false
      this.showError404 = false
    },
    showNotFoundError () {
      this.showError404 = true
    },
    setMaintenance () {
      this.showMaintenance = true
    },
    showForbiddenError () {
      this.showError403 = true
    },
    toggleMobileSidebar (value: boolean) {
      this.showMobileSidebar = value
    },
  },
})
